import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/readReceipt.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleMarkedAsReadEvent } from './Types'

interface Props extends ActivityEventPosition {
  event: ArticleMarkedAsReadEvent
}

const ArticleMarkedAsRead = ({ event, ...props }: Props) => {
  const { user } = event

  return (
    <BaseActivityEvent
      {...props}
      icon={<Icon />}
      timestamp={event.timestamp}
      content={
        <>
          <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> marked as read
        </>
      }
    />
  )
}

export { ArticleMarkedAsRead }
